import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { useAtomValue } from 'jotai';
import { ArrowRight, Check, Copy, Globe, MessageCircle, Wallet } from 'lucide-react';
import { useState } from 'react';
import { useJupiterModal } from '../../hooks/useJupiterModal';
import { useResetSearch } from '../../hooks/useResetSearch';
import { ShareX } from './ShareX';
import { SocialLink } from './SocialLink';

export const ActionPanel = () => {
  const tokenInfoResult = useAtomValue(tokenInfoAtom);
  const [copied, setCopied] = useState(false);
  const { handleReset } = useResetSearch();

  if (!tokenInfoResult) return null;

  const { ca, website, x, tg } = tokenInfoResult;
  const { openJupiterModal } = useJupiterModal(ca);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(ca);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="w-full flex flex-col md:flex-row items-start md:items-center gap-4 flex-wrap">
      <div className="flex flex-row gap-3 w-full md:w-fit flex-1">
        <div
          className="box-border truncate h-[42px] inline-flex items-center gap-2 bg-gray-800 rounded px-4 cursor-pointer hover:bg-gray-700 transition-all"
          onClick={handleCopy}
        >
          <code className="font-mono text-sm text-gray-300 truncate">{ca || 'N/A'}</code>
          <div className="min-w-[20px] h-[20px] ml-auto">
            {copied ? (
              <Check className="text-white w-full h-full" />
            ) : (
              <Copy className="text-white w-full h-full" />
            )}
          </div>
        </div>
        <button
          onClick={handleReset}
          className="w-fit px-4 py-2 flex flex-row gap-2 items-center justify-center rounded-md relative whitespace-nowrap transition-all duration-500 bg-gradient-to-r from-blue-500/30 to-purple-500/30 bg-size-200 bg-pos-0 hover:bg-pos-100"
        >
          <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Try another
          </span>
          <ArrowRight className="h-4 w-4 stroke-blue-400" />
        </button>
      </div>

      <div className="flex-row flex w-full md:w-fit flex-1 items-center gap-4 flex-wrap min-w-[200px]">
        <div className="flex items-center justify-center">
          <ShareX />
        </div>

        <div className="w-fit flex gap-3 flex-1 flex-row justify-end items-center">
          <button
            onClick={openJupiterModal}
            className="w-fit px-4 py-2 flex flex-row gap-2 items-center justify-center rounded-md relative whitespace-nowrap transition-all duration-500 bg-gradient-to-r from-blue-500/30 to-purple-500/30 bg-size-200 bg-pos-0 hover:bg-pos-100"
          >
            <Wallet className="h-4 w-4 stroke-blue-400" />
            <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Trade
            </span>
          </button>
          <SocialLink url={website || ''} icon={Globe} />
          <SocialLink url={tg || ''} icon={MessageCircle} />
        </div>
      </div>
    </div>
  );
};
